import type { FlowId } from '@/flows/types';
import type { AccessGroupDraft } from '@/types/accessGroupCreation';
import type { DeviceDraft } from '@/types/deviceSetup';
import type { UserDraft } from '@/types/userCreation';

const PREFIX: Record<FlowId, string> = {
  'user-creation': 'ux3_user_creation_seed:',
  'device-setup': 'ux3_device_setup_seed:',
  'access-group-creation': 'ux3_access_group_seed:',
  'bulk-user-import': 'ux3_bulk_user_import_seed:',
};

export type FlowPrefill = Partial<UserDraft> | Partial<DeviceDraft> | Partial<AccessGroupDraft>;

export function setFlowPrefill(
  flowId: FlowId,
  conversationId: string,
  prefill: FlowPrefill
): void {
  sessionStorage.setItem(`${PREFIX[flowId]}${conversationId}`, JSON.stringify(prefill));
}

export function consumeFlowPrefill<T extends object>(
  flowId: FlowId,
  conversationId: string
): Partial<T> | null {
  const key = `${PREFIX[flowId]}${conversationId}`;
  const raw = sessionStorage.getItem(key);
  if (!raw) return null;
  sessionStorage.removeItem(key);
  try {
    return JSON.parse(raw) as Partial<T>;
  } catch {
    return null;
  }
}
